import { render, staticRenderFns } from "./RelatedLeadsAlert.vue?vue&type=template&id=7aba700c&"
import script from "./RelatedLeadsAlert.vue?vue&type=script&lang=js&"
export * from "./RelatedLeadsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports